import { formatCurrency, startOfLocalDayInput, defaultLocalDateToInput, resolveCreditPeriodTotalsRequest } from '@smarttransit/common'
import { addAlert } from '../../utilities/helpers'
import { getCreditPeriodTotals } from '../../services/agents-service'

export default {
  name: 'credit-period-totals-dialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    agentProfileId: String,
    agentName: {
      type: String,
      default: ''
    },
    currencySymbol: {
      type: String,
      default: ''
    },
    showProfit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dateFrom: startOfLocalDayInput(),
      dateTo: defaultLocalDateToInput(),
      totals: null,
      totalsLoading: false,
      totalsError: null,
      totalsLoadId: 0
    }
  },
  computed: {
    dialogModel: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    canLoadTotals () {
      return !!(this.agentProfileId && this.dateFrom && this.dateTo)
    },
    profitIsNegative () {
      return !!(this.totals && this.totals.profit < 0)
    }
  },
  watch: {
    value (open) {
      if (open) {
        this.resetAndLoad()
      }
    }
  },
  methods: {
    closeDialog () {
      this.dialogModel = false
    },
    formatMoney (cents) {
      return formatCurrency(cents, this.currencySymbol)
    },
    resetAndLoad () {
      this.dateFrom = startOfLocalDayInput()
      this.dateTo = defaultLocalDateToInput()
      this.totals = null
      this.totalsError = null
      this.loadTotals()
    },
    async loadTotals () {
      const request = resolveCreditPeriodTotalsRequest({
        agentProfileId: this.agentProfileId,
        dateFromLocal: this.dateFrom,
        dateToLocal: this.dateTo
      })

      if (request.error) {
        this.totals = null
        this.totalsError = request.error
        return
      }

      const requestId = this.totalsLoadId + 1
      this.totalsLoadId = requestId
      this.totalsLoading = true
      this.totalsError = null

      try {
        const totals = await getCreditPeriodTotals({
          agentProfileId: this.agentProfileId,
          dateFrom: request.dateFrom,
          dateTo: request.dateTo
        })
        if (requestId !== this.totalsLoadId) {
          return
        }
        this.totals = totals
      } catch (err) {
        if (requestId !== this.totalsLoadId) {
          return
        }
        this.totals = null
        this.totalsError = (err && err.message) || 'Could not load period totals'
        addAlert({ message: err, type: 'error' })
      } finally {
        if (requestId === this.totalsLoadId) {
          this.totalsLoading = false
        }
      }
    }
  }
}
